import styles from './settingsForm.module.css';
import { PageEnableToggleButton, RemovePageButton } from './pageActions.js';

export interface ResetSettingsButtonProps {
  /** Page name shown in the confirm dialog ("Home", "Calendar", …). */
  pageLabel: string;
  /** Resets every saved value for this page. Caller fans out to the
   *  appropriate API calls (PATCH settings, DELETE list items, …). */
  onReset: () => void;
  disabled?: boolean;
}

/**
 * Small destructive-action button rendered in the top-right of each
 * page settings panel. Fronts a window.confirm dialog so a slip on a
 * Promethean board doesn't wipe the teacher's prep.
 */
export function ResetSettingsButton({ pageLabel, onReset, disabled }: ResetSettingsButtonProps) {
  const handle = () => {
    const ok = window.confirm(
      `Reset ${pageLabel} settings to defaults?\n\n` +
        `This clears every saved value on the ${pageLabel} page for this classroom. Settings ` +
        `on other pages are not affected.`,
    );
    if (ok) onReset();
  };
  return (
    <div className={styles.actions}>
      <button
        type="button"
        className={styles.resetButton}
        onClick={handle}
        disabled={disabled}
        data-testid={`reset-${pageLabel.toLowerCase().replace(/\s+/g, '-')}-settings`}
      >
        Reset settings
      </button>
      <PageEnableToggleButton />
      <RemovePageButton />
    </div>
  );
}
